import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import VisionBoardUserDetail from './VisionBoardUserDetail';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyVisionBoardUserDetail } from './companyVisionBoardApi';

/**
 * Company Vision Board → one employee's/member's board activity.
 * Reuses the shared detail page with the company-scoped fetcher (the backend
 * 404s any user who doesn't belong to this company).
 */
const CVisionBoardUserDetail = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>User Vision Board | Shoorah</title>
      </Helmet>
      <VisionBoardUserDetail
        fetcher={fetchCompanyVisionBoardUserDetail}
        backPath={`/${slug}/self-development/vision-board/users`}
        backLabel={isB2BFansMode ? 'Back to Members' : 'Back to Employees'}
      />
    </div>
  );
};

export default CVisionBoardUserDetail;
